import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { HygraphService } from '@app/@shared/services/hygraph/hygraph.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { of } from 'rxjs';
import { catchError, concatMap, map } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-asset-redirect',
  standalone: true,
  imports: [],
  template: ''
})
export class AssetRedirectComponent implements OnInit {
  constructor(
    private readonly hygraphService: HygraphService,
    private readonly router: Router,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.route.paramMap.pipe(
      concatMap((params: ParamMap) => {
        if (!params.has('reportId')) {
          return of(this.router.createUrlTree(['/404']));
        } else {
          return this.hygraphService.getContentIdFromAssetId(params.get('reportId')).pipe(
            map(contentId => contentId
              ? this.router.createUrlTree(['/hg-content', contentId], { preserveFragment: true, queryParamsHandling: 'preserve' })
              : this.router.createUrlTree(['/404'])
            ),
            catchError(() => of(this.router.createUrlTree(['/404'])))
          )
        }
      }),
      untilDestroyed(this)
    ).subscribe((urlTree) => {
      this.router.navigateByUrl(urlTree);
    });
  }
}
